exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.retail-shell[data-v-6bcd075d] {\n  height: 100vh;\n  overflow: hidden;\n  background: #f5f5f5;\n}\n/* 独立窗口无 TabLayout 头部：覆写 CashierDesk 的 calc(100vh-130px) 为整屏（子根元素可命中父 scoped 样式） */\n.retail-shell .cashier-desk[data-v-6bcd075d] {\n  height: 100vh;\n}\n", ""]);

// exports
